// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__WClNX","social_list":"Footer_social_list__LmjW8","copy_right":"Footer_copy_right__ge6Yo"};